/** Date → "YYYY-MM-DD" */
export const toDateString = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/** "YYYY-MM-DD" → Date (local, no TZ shift). Returns undefined for invalid input. */
export const parseDateString = (value: string): Date | undefined => {
  if (!value) return undefined;
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return undefined;
  const date = new Date(y, m - 1, d);
  if (isNaN(date.getTime())) return undefined;
  return date;
};

/** "YYYY-MM-DD" → human-readable string via Intl.DateTimeFormat */
export const formatDisplayDate = (value: string, locale?: string): string => {
  const date = parseDateString(value);
  if (!date) return '';
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};
